import { render, staticRenderFns } from "./AdminProfile.vue?vue&type=template&id=5c29e966&scoped=true&"
import script from "./AdminProfile.vue?vue&type=script&lang=js&"
export * from "./AdminProfile.vue?vue&type=script&lang=js&"
import style0 from "./AdminProfile.vue?vue&type=style&index=0&id=5c29e966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c29e966",
  null
  
)

export default component.exports